import * as ROUTES from "../../../resources/routes-name";

export const matchUrlMenuSidebar = (pathname: string) => {
  if (pathname === ROUTES.ROUTE_HANDLE) {
    return false;
  } else {
    return true;
  }
};
